<template>
	<div>
		<section class="filters">
			<div class="container">
				<div class="row">
					<div class="hidden-md col-3"><h3 class="filters__headline filters__headline--desktop">{{$t('filters.search')}}</h3></div>
					<div class="hidden-md col-2"><h3 class="filters__headline filters__headline--desktop">{{$t('filters.narrow')}}</h3></div>
					<div class="hidden-md col-2"></div>
					<div class="hidden-md col-2">
						<h3 class="filters__headline filters__headline--desktop">
							{{$t('filters.sort')}}
						</h3>
					</div>
					<div class="hidden-md col-2"></div>
					<div class="hidden-md col-1"></div>
				</div>
				<div class="row">
					<div class="hidden-md-up col-12">
						<h3 @click="openFiltersTabs('search')" class="filters__headline filters__headline--mobile">
							{{$t('filters.search')}}
							<img class="filters__arrow" :class="{'filters__arrow--close': openFilters === 'search'}" src="../../../static/img/mobile-arrow-down.png" alt="">
						</h3>
					</div>
					<NameFilterComponent :openFilters="openFilters"></NameFilterComponent>
					<div class="hidden-md-up col-12">
						<h3 @click="openFiltersTabs('narrow')" class="filters__headline filters__headline--mobile">{{$t('filters.narrow')}} <img class="filters__arrow" :class="{'filters__arrow--close': openFilters === 'narrow'}" src="../../../static/img/mobile-arrow-down.png" alt=""></h3>
					</div>
					<AlphabeticFilterComponent :openFilters="openFilters"></AlphabeticFilterComponent>
					<CountryFilterComponent :openFilters="openFilters"></CountryFilterComponent>
					<div class="hidden-md-up col-12">
						<h3 @click="openFiltersTabs('sort')" class="filters__headline filters__headline--mobile">{{$t('filters.sort')}} <img class="filters__arrow" :class="{'filters__arrow--close': openFilters === 'sort'}" src="../../../static/img/mobile-arrow-down.png" alt=""></h3>
					</div>
					<SortFilterComponent
						:openFilters="openFilters"
						:name="'stars'"
					/>
					<SortFilterComponent
						:openFilters="openFilters"
						:name="'reviews'"
					/>
				</div>
			</div>
		</section>
		<section class="selected">
			<div class="container">
				<div class="row">
					<div v-if="$store.getters.isAnyJudgesFilterSelected" class="col-sm-12 col-md-2 col-lg-1">
						<span class="selected__label">
							{{ $t('filters.buttonResultsName') }}
						</span>
					</div>

					<div v-else class="selected__label-wrapper col-sm-12 col-md-12 col-lg-1">
						<span class="selected__label selected__label--no-filters">
							{{ $t('filters.buttonNoResultsName') }}
						</span>
					</div>

					<div class="col-11">
						<div class="selected__filters">
							<span
								v-if="$store.state.judges.activeName"
								class="selected__filter"
								@click="removeNameFilter"
							>
								{{ $store.state.judges.activeName }}
								<img src="/static/img/close.svg" alt="">
							</span>

							<span
								v-if="$store.state.judges.activeLetter"
								class="selected__filter"
								@click="removeLetterFilter"
							>
								{{ $store.state.judges.activeLetter }}
								<img src="/static/img/close.svg" alt="">
							</span>

							<span
								v-for="country in $store.state.judges.activeCountries"
								:key="country.code"
								class="selected__filter"
								@click="removeCountryFilter(country)"
							>
								{{ country.name }}
								<img src="/static/img/close.svg" alt="">
							</span>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import SortFilterComponent from './Filters/SortFilterComponent'
	import CountryFilterComponent from './Filters/CountryFilterComponent'
	import NameFilterComponent from './Filters/NameFilterComponent'
	import AlphabeticFilterComponent from './Filters/AlphabeticFilterComponent'
	import { mapActions } from 'vuex'

	export default {
		components: {
			SortFilterComponent,
			CountryFilterComponent,
			NameFilterComponent,
			AlphabeticFilterComponent
		},
		data () {
			return {
				openFilters: '',
				selectedFilters: {
					alphabetic: '',
					stars: '',
					reviews: ''
				}
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			removeNameFilter () {
				this.$store.commit('removeName')
				this.fetchJudges()
			},
			removeLetterFilter () {
				this.$store.commit('removeLetter')
				this.fetchJudges()
			},
			removeCountryFilter (item) {
				this.$store.commit('removeCountry', item)
				this.fetchJudges()
			},
			openFiltersTabs (filters) {
				if (filters === this.openFilters) {
					this.openFilters = ''
				} else {
					this.openFilters = filters
				}
			}
		},
		created () {
			document.addEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.filters {
		padding: 25px 0;
		background-color: #aa9f8b;
		&__headline {
			text-align: left;
			font-size: 14px;
			font-family: $lato-bold;
			text-transform: uppercase;
			margin: 0 0 15px;

			display: flex;
			align-items: center;
		}
		&__arrow {
			margin-left: 5px;
		}
	}
	.selected {
		padding: 40px 0 0;
		background-color: $gray-light;
        &__label-wrapper {
            display: none;
        }
		&__label {
			text-transform: uppercase;
			display: block;
			width: 100%;
			height: 40px;
			background-color: $gold;
			font-family: $lato-bold;
			font-size: 13px;
			color: #fff;
			padding: 12px 0;
		}
		&__filters {
			display: flex;
			flex-wrap: wrap;
		}
		&__filter {
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 15px;
			margin-right: 20px;
			margin-bottom: 20px;
			min-width: 170px;
			height: 40px;
			background-color: #fff;
			font-size: 14px;
			color: $gray-filter;
			img {
				margin-left: 10px;
			}
		}
	}

	@media (max-width: 991.98px) {
		.filters {
			padding: 20px 0 10px;
			&__arrow--close {
				transform: rotate(180deg);
			}
		}
		.selected {
			padding: 20px 0 0;
            &__label-wrapper {
                display: block;
            }
			&__label {
				max-width: 80px;
				margin-bottom: 20px;
                &--no-filters {
                    max-width: max-content;
                    padding: 20px;
                    height: auto;
                }
			}
			&__filter {
				margin-right: 10px;
				margin-bottom: 15px;
				min-width: 130px;
				font-size: 13px;
			}
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/FiltersComponents.vue